export enum PopupState {
  CLOSED,
  LOGIN,
  LOGOUT,
  SITE_SWITCH
}

export default PopupState;
